export default {
  "GoogleApiKey": "AIzaSyAKh_GGlDJ657GWLpd77I0AG3Bec053Xsw",
  "MapStyle": [{
    "elementType": "labels.text",
    "stylers": [{
      "lightness": 35
    }]
  }, {
    "featureType": "road",
    "elementType": "labels.icon",
    "stylers": [{
      "saturation": -25
    }, {
      "lightness": 30
    }]
  }, {
    "featureType": "landscape",
    "stylers": [{
      "saturation": -100
    }, {
      "lightness": 50
    }]
  }, {
    "featureType": "landscape",
    "elementType": "labels.icon",
    "stylers": [{
      "visibility": "off"
    }]
  }, {
    "featureType": "poi",
    "stylers": [{
      "hue": "#00ffff"
    }, {
      "saturation": -50
    }, {
      "lightness": 51
    }, {
      "visibility": "simplified"
    }]
  }, {
    "featureType": "poi",
    "stylers": [{
      "visibility": "off"
    }]
  }, {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [{
      "hue": "#ffd500"
    }, {
      "saturation": -55
    }, {
      "lightness": 55
    }]
  }, {
    "featureType": "road.highway.controlled_access",
    "stylers": [{
      "hue": "#ffa200"
    }]
  }, {
    "featureType": "road.arterial",
    "stylers": [{
      "saturation": -10
    }, {
      "lightness": 30
    }]
  }, {
    "featureType": "road",
    "elementType": "labels.text.fill",
    "stylers": [{
      "lightness": -17
    }]
  }, {
    "featureType": "road.highway",
    "elementType": "labels",
    "stylers": [{
      "saturation": -100
    }, {
      "lightness": 50
    }]
  }, {
    "featureType": "transit.line",
    "elementType": "geometry",
    "stylers": [{
      "lightness": 20
    }]
  }, {
    "featureType": "transit.station",
    "stylers": [{
      "visibility": "off"
    }]
  }, {
    "featureType": "administrative",
    "stylers": [{
      "saturation": -70
    }, {
      "lightness": 20
    }, {
      "visibility": "simplified"
    }]
  }, {
    "featureType": "administrative.neighborhood",
    "stylers": [{
      "visibility": "off"
    }]
  }, {
    "featureType": "administrative.land_parcel",
    "elementType": "labels",
    "stylers": [{
      "visibility": "off"
    }]
  }, {
    "featureType": "water",
    "stylers": [{
      "saturation": -20
    }, {
      "lightness": 30
    }]
  }],
  "MediaQueries": {
    "width": {
      "tiny": 350,
      "small": 450,
      "medium": 600,
      "large": 800,
      "larger": 950,
      "full": 1150,
      "high": 1350,
      "higher": 1600,
      "cinema": 1800
    },
    "height": {
      "tiny": 300,
      "small": 400,
      "medium": 600,
      "large": 800,
      "larger": 900,
      "full": 1000,
      "high": 1100,
      "cinema": 1200
    }
  },
  "TransitionTimes": {
    "slower": 1000,
    "slow": 500,
    "medium": 350,
    "normal": 250,
    "fast": 100
  }
};